import type { VenueEvent } from 'types/model'

import { getInventoryBrowseDiaryDayKey } from '@utils/date-time'

/** Match event diary calendar day to the selected inventory browse day (local wall calendar). */
export function findVenueEventForInventoryDate(
  events: VenueEvent[],
  inventoryDateIso: string
): VenueEvent | undefined {
  const targetKey = getInventoryBrowseDiaryDayKey(inventoryDateIso)
  if (!targetKey) return undefined

  return events.find((e) => {
    const raw = e.date
    const eventInstant =
      typeof raw === 'number'
        ? raw
        : typeof raw === 'string'
          ? Date.parse(raw)
          : Date.parse(String(raw))
    if (!Number.isFinite(eventInstant)) return false

    const eventKey = getInventoryBrowseDiaryDayKey(eventInstant)
    return eventKey === targetKey
  })
}
